
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/appTimeline",
      function () {
        return require("private-next-pages/appTimeline/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/appTimeline"])
      });
    }
  